module.exports = __webpack_public_path__ + "img/project-new_task_filled.138224a1.png";